import * as React from 'react'
import styled from 'styled-components'
import FooterButton from './FooterButton'

const FooterDiv = styled.div`
  position: absolute;
  /* background-color: #101010; */
  /* height: 7.5vh; */
  height: 100px;
  width: 100%;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

const ButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 80%;
`

const Footer = (): JSX.Element => {
  return (
    <div>
      <FooterDiv>
        <ButtonDiv>
          <FooterButton text="Manifesto" link="https://glass-manifesto.super.site" />
          <FooterButton text="Terms" link="https://glass.xyz/terms" />
          <FooterButton text="Privacy" link="https://glass.xyz/privacy" />
          <FooterButton
            text="Twitter"
            link="https://twitter.com/intent/follow?screen_name=GlassProtocol"
          />
          <FooterButton text="Mirror" link="https://glass.mirror.xyz/" />
          <FooterButton text="Discord" link="http://discord.gg/FdBj6ZBuuJ" />
        </ButtonDiv>
      </FooterDiv>
    </div>
  )
}

export default Footer
